import React, { useMemo } from "react";

const ServicesProcess = () => {
  const steps = useMemo(
    () => [
      {
        num: "01",
        title: "Discovery",
        desc: "Align on goals, constraints, and success metrics.",
        icon: "🔍"
      },
      {
        num: "02",
        title: "Design",
        desc: "Select tools, routines, and training paths.",
        icon: "🧠"
      },
      {
        num: "03",
        title: "Deliver",
        desc: "Hands-on workshops, coaching, and execution.",
        icon: "⚙️"
      },
      {
        num: "04",
        title: "Sustain",
        desc: "Standard work and reinforcement for lasting gains.",
        icon: "🔁"
      }
    ],
    []
  );

  return (
    <section className="w-full bg-[color:var(--surface)]" id="process">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <h2 className="text-3xl font-semibold text-[color:var(--navy)]">
          Our delivery framework
        </h2>

        <div className="mt-12 grid gap-6 lg:grid-cols-4">
          {steps.map((s) => (
            <div
              key={s.num}
              className="group rounded-2xl border border-[color:var(--border)] bg-white p-6 transition hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="flex items-center justify-between">
                <div className="text-xs font-semibold text-[color:var(--muted)]">
                  {s.num}
                </div>
                <div className="text-2xl">{s.icon}</div>
              </div>

              <div className="mt-4 text-lg font-semibold text-[color:var(--navy)]">
                {s.title}
              </div>

              <p className="mt-2 text-sm text-[color:var(--muted)] leading-relaxed">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesProcess;
